import { Currency, PlanProduct } from '../../../../../types';
import { fCurrencyByUnit, FcurrencyByUnitOptions } from '../../../../../utils';

export function formatPricePerCcu(
  price: number,
  maxCcu: number,
  currency: Currency,
) {
  // MEMO: 달러는 1.22, 원/엔화는 1000 or 100 이렇게 소수는 잘라서 출력
  return Number((price / maxCcu).toFixed(currency === 'USD' ? 2 : 0));
}

export const getPricingCardText = (
  plan: PlanProduct | undefined,
  isSelectedInfinity: boolean,
  fCurrencyByUnitOptions: FcurrencyByUnitOptions,
  monthCount = 1,
): {
  discountRate: string;
  salePrice: string;
  originalPrice: string;
} => {
  if (isSelectedInfinity || !plan) {
    return {
      discountRate: '',
      salePrice: '-',
      originalPrice: '',
    };
  }

  return {
    discountRate: plan?.saleDiscountRate ? `${plan?.saleDiscountRate}%` : '',
    salePrice: fCurrencyByUnit(
      plan?.salePrice / monthCount,
      plan?.currency,
      fCurrencyByUnitOptions,
    ),
    originalPrice: fCurrencyByUnit(
      plan?.originalPrice / monthCount,
      plan?.currency,
      fCurrencyByUnitOptions,
    ),
  };
};
